import { render } from "./chaxuna.vue?vue&type=template&id=fd2f093c&scoped=true"
import script from "./chaxuna.vue?vue&type=script&lang=js"
export * from "./chaxuna.vue?vue&type=script&lang=js"

import "./chaxuna.vue?vue&type=style&index=0&id=fd2f093c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd2f093c"

export default script